var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner spinner--two-cube",style:(_vm.styles)},[_c('div',{staticClass:"cube1",style:(_vm.cubeStyles)}),_c('div',{staticClass:"cube2",style:(_vm.cubeStyles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }